$( document ).ready(function() {
   $(function(){
  $('.beforeAfter').beforeAfter();
});
  $('.beforeAfter').beforeAfter({

  // is draggable/swipeable
  movable: true,

  // click image to move the slider
  clickMove: true,

  // always show the slider
  alwaysShow: true,

  // intial position of the slider
  position: 50,

  // opacity between 0 and 1
  opacity: 0.4,
  activeOpacity: 1,
  hoverOpacity: 0.8,

  // slider colors
  separatorColor: '#ffffff',
  bulletColor: '#ffffff',
  arrowColor: '#33333',
  
});

  // testimonials js
  $('.testimonials--inner').slick({
          arrows: true,
    dots: false,
    centerMode: true,
  centerPadding: '60px',
  slidesToShow: 3,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                
                slidesToShow: 1,
                slidesToScroll: 1

    
              }
            },
            {
              breakpoint: 600,
              settings: {
               
                slidesToShow: 1,
                slidesToScroll: 1

              }
            },
            {
              breakpoint: 480,
              settings: {
                
                slidesToShow: 1,
                slidesToScroll: 1,
                centerPadding: '10px'
              }
            }
          ]
        });


  // --------------------------
  $(".slider-btn--prev").click(function(){
  $(this).parents('.testimonials--main').find('.slick-prev').click();
});
  $(".slider-btn--next").click(function(){
  $(this).parents('.testimonials--main').find('.slick-next').click();
});
});